import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faCircleNotch, faShareFromSquare, faXmark } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import { formatCurrency } from '../utils/currencyUtils';
import Modal from 'react-modal';

function PositionMobile({index, tradeasset, trade}) {
  const [loading, setLoading] = useState(false);
  const [marketPrice, setMarketPrice] = useState(trade.current_price);
  const [liqPrice, setLiqPrice] = useState(trade.liq_price);
  const [pandl, setPandl] = useState(trade.pl_roi);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [tp, setTp] = useState(trade.tp);
  const [sl, setSl] = useState(trade.sl);
  const [trailing, setTrailing] = useState(trade.trailing_stop);

  useEffect(() => {
    let isCancelled = false;
    const fetchFutures = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchpandl: true, tradeID: trade.order_id })
      })
        .then(r => r.json())
        .then(data => {
          if (isCancelled) return;
          if (data.status === "success" && data.trade) {
            const t = data.trade;
            const nextMarket = Number(t.current_price) || 0;
            const nextLiq    = Number(t.liq_price) || 0;
            const nextPnL    = Number(t.pl_roi) || 0;
            setMarketPrice(prev => (nextMarket === prev ? prev - 0.01 : nextMarket));
            setLiqPrice(prev => (nextLiq === prev ? prev - 0.01 : nextLiq));
            setPandl(prev => (nextPnL === prev ? prev - 0.01 : nextPnL));
          }
        })
        .catch(() => {});
    };
    fetchFutures();
    const interval = setInterval(fetchFutures, 5000);
    return () => {
      isCancelled = true;
      clearInterval(interval);
    };
  }, [trade.order_id]);

  const CloseFuture = (tradeid) =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ closeFuture : true, tradeid: tradeid })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    })
  }
  const SetTPSL = (tradeid) =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ setTPSL : true, tradeid: tradeid, tp: tp, sl: sl })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setIsOpen1(false);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    })
  }   
  const SetTrailing = (tradeid) =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ setTrailing : true, tradeid: tradeid, trailing: trailing })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setIsOpen2(false);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    })
  } 

  const notional = Number(trade.amount) * Number(trade.leverage);
  const qty = trade.price ? (notional / Number(trade.price)) : 0;
  const pnlPct = Number(trade.amount) ? (pandl / Number(trade.amount)) * 100 : 0;

  if (!tradeasset) {
    return <div style={{ textAlign: "center", marginTop: "20%", marginBottom: "20%"}}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <>
      <div>
        <hr className="mb-2 mt-0"/>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <h6 className="mb-0 me-1" style={{fontWeight:'900'}}>{tradeasset.symbol}USDT</h6>
            <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} />
          </div>
          <FontAwesomeIcon icon={faShareFromSquare} style={{fontSize: '12px'}} />
        </div>
        <div className="d-flex align-items-center">
          <div className={`mycard px-2 py-1 fw-bold rounded-2 ${trade.side == "Long"?'text-success':'text-danger'}`} style={{fontSize:'11px',backgroundColor: trade.side === 'Long' ? 'rgba(25, 135, 84, 0.1)' : 'rgba(135, 25, 25, 0.1)'}}>{trade.side}</div>
          <p className="mb-0 ms-2" style={{fontSize:'11px'}}>{trade.future_type}</p>
          <p className="mb-0 ms-4" style={{fontSize:'11px'}}>{trade.leverage}x</p>
        </div>
        <div className="mt-2 d-flex align-items-center justify-content-between">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Unrealized P&L</p>
            <h6 className="mb-0 text-success" style={{fontWeight:'900'}}>{Number(pandl).toFixed(6)}</h6>
          </div>
          <div className="text-end"> 
            <p className="mb-0 " style={{fontSize:'11px'}}>ROI</p>
            <h6 className="mb-0 text-success" style={{fontWeight:'900'}}>{pnlPct.toFixed(2)}%</h6>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-2">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Amount ({tradeasset.symbol})</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{qty.toFixed(4)}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Margin (USDT)</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{formatCurrency(notional)}</p>
          </div>
          <div className="text-end">
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>TP/SL (USDT)</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{tp && sl ? `${formatCurrency(tp)}/${formatCurrency(sl)}` : '--'}</p>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-2">
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Av. Entry Price (USDT)</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{formatCurrency(trade.price)}</p>
          </div>
          <div>
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Market Price (USDT)</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{formatCurrency(marketPrice)}</p>
          </div>
          <div className="text-end">
            <p className="mb-0 text-secondary" style={{fontSize:'11px'}}>Liq. price</p>
            <p className="mb-0" style={{fontSize:'11px'}}>{formatCurrency(liqPrice)}</p>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div className="myBtn rounded-pill px-3 py-1" style={{fontSize:'11px',backgroundColor:'#ffffff14'}} onClick={() => setIsOpen1(true)}>Set TP/SL</div>
          <div className="myBtn rounded-pill px-3 py-1" style={{fontSize:'11px',backgroundColor:'#ffffff14'}} onClick={() => setIsOpen(true)}>Close</div>
          <div className="myBtn rounded-pill px-2 py-1" style={{fontSize:'11px',backgroundColor:'#ffffff14'}} onClick={() => setIsOpen(true)}>Market close</div>
          <div className="myBtn rounded-pill px-2 py-1" style={{fontSize:'11px',backgroundColor:'#ffffff14'}} onClick={() => setIsOpen2(true)}>Trailing Stop</div>
        </div>
      </div>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
      >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-danger" style={{fontSize: '16px'}}>Warning</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <p className="mb-0 fw-bold">Close Trade</p>
          <p className="mt-1 mb-0" style={{lineHeight: '120%',fontSize:'14px'}}>
              You are about to <span className="text-danger font-700">close this trade (Order #{trade.order_id})</span>.<br/>
              This action is irreversible and this position will be closed immediately.<br/>
              Are you sure you want to proceed?
          </p>
          <div className={`myBtn w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => CloseFuture(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Close Trade'}</div>
      </Modal>
      <Modal
          isOpen={modalIsOpen1}
          onRequestClose={() => setIsOpen1(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
      >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
              Set TP/SL</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
          </div>
          <div className="row">
            <div className="col-6"> 
              <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Take Profit:</label>
              <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                  <input 
                    type="number"
                    className="inputNone"
                    value={tp}
                    onChange={(e) => setTp(e.target.value)}
                  />
                  <div
                    className="fw-bold text-white d-flex align-items-center"
                    style={{
                      backgroundColor: 'rgb(30, 33, 36)',
                      borderRadius: '4px',
                      padding: '6px',
                      fontSize: '14px',
                      cursor: 'pointer' 
                    }}
                  >
                  USDT
                  </div>
              </div>
            </div>
            <div className="col-6">
              <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Stop Loss:</label>
              <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                  <input 
                    type="number"
                    className="inputNone"
                    value={sl}
                    onChange={(e) => setSl(e.target.value)}
                  />
                  <div
                    className="fw-bold text-white d-flex align-items-center"
                    style={{
                      backgroundColor: 'rgb(30, 33, 36)',
                      borderRadius: '4px',
                      padding: '6px',
                      fontSize: '14px',
                      cursor: 'pointer' 
                    }}
                  >
                  USDT
                  </div>
              </div>
            </div>
          </div> 
          <div className={`myBtn w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => SetTPSL(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
      </Modal>
      <Modal
          isOpen={modalIsOpen2}
          onRequestClose={() => setIsOpen2(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
      >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
              Set Trailing Stop</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Trailing Stop (%):</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                className="inputNone"
                value={trailing}
                onChange={(e) => setTrailing(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
              USDT
              </div>
          </div>

          <div className={`myBtn w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => SetTrailing(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
      </Modal>
    </>
  )
}
 
export default PositionMobile